// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import type { Communication, Patient } from '@medplum/fhirtypes';

export const PATIENT_UPDATED_EVENT = 'polaris:patient-updated';
export const PATIENT_CREATED_EVENT = 'polaris:patient-created';
export const COMMUNICATION_CREATED_EVENT = 'polaris:communication-created';

export function dispatchPatientCreated(patient: Patient): void {
  window.dispatchEvent(new CustomEvent<Patient>(PATIENT_CREATED_EVENT, { detail: patient }));
}

export function dispatchPatientUpdated(patient: Patient): void {
  window.dispatchEvent(new CustomEvent<Patient>(PATIENT_UPDATED_EVENT, { detail: patient }));
}

export function dispatchCommunicationCreated(communication: Communication): void {
  window.dispatchEvent(new CustomEvent<Communication>(COMMUNICATION_CREATED_EVENT, { detail: communication }));
}
